import type { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';

import { createStyleHelper } from '../../../shared/utils/class-names';
import { ResponsibleGamingMenu } from '../../components/responsible-gaming-menu/responsible-gaming-menu';

import styles from './responsible-gaming.module.scss';

const style = createStyleHelper(styles, 'responsible-gaming');

export const ResponsibleGamingLayout: FunctionComponent = () => {
    return (
        <div className={style()}>
            <div className={style('menu')}>
                <ResponsibleGamingMenu />
            </div>
            <Outlet />
        </div>
    );
};
